/** "business" module DTOs unique keys */
export enum BusinessDtoKeysEnum {
  /** Deal order response body */
  DEAL_ORDER_FIND_DTO = 'business/deal-order-find.dto',
  /** Deal order create or update request body */
  DEAL_ORDER_FORM_DTO = 'business/deal-order-form.dto',
  /** Query parameters (additional options) for find one deal API */
  DEAL_FIND_ONE_QUERY_DTO = 'business/deal-find-one-query.dto',
  /** Deal response body */
  DEAL_FIND_DTO = 'business/deal-find.dto',
  /** Deal page response body */
  DEAL_PAGE_FIND_DTO = 'business/deal-page-find.dto',
  /** Deal status export to file API query parameters */
  DEAL_STATUS_EXPORT_QUERY_DTO = 'business/deal-status-export-query.dto',
  /** Deal status find many API query parameters */
  DEAL_STATUS_FIND_MANY_QUERY_DTO = 'business/deal-status-find-many-query.dto',
  /** Deal status find one API query parameters */
  DEAL_STATUS_FIND_ONE_QUERY_DTO = 'business/deal-status-find-one-query.dto',
  /** Deal status response body */
  DEAL_STATUS_FIND_DTO = 'business/deal-status-find.dto',
  /** Deal group response body */
  DEAL_GROUP_FIND_DTO = 'business/deal-group-find.dto',
  /** Deal fact time response body */
  DEAL_FACT_TIME_FIND_DTO = 'business/deal-fact-time-find.dto',
  /** Document statistic response body */
  DOCUMENT_STATISTIC_FIND_DTO = 'business/document-statistic-find.dto',
  /** File attached to deal response body */
  DEAL_FILE_FIND_DTO = 'business/deal-file-find.dto',
  /** Deal synchronize history response body */
  DEAL_SYNCHRONIZE_HISTORY_FIND_DTO = 'business/deal-synchronize-history-find.dto',
  /** Deal registry page response body */
  DEAL_REGISTRY_PAGE_DTO = 'business/deal-registry-page.dto',
  /** Query parameters (additional options) for search deal API */
  DEAL_SEARCH_QUERY_DTO = 'business/deal-search-query.dto',
  /** Deal status swithch API request body */
  DEAL_STATUS_SWITCH_DTO = 'business/deal-status-switch.dto',
  /** Deal subtotal API response body item */
  DEAL_SUBTOTAL_ITEM_DTO = 'business/deal-subtotal-item.dto',
  /** Deal subtotal API query parameters */
  DEAL_SUBTOTAL_QUERY_DTO = 'business/deal-subtotal-query.dto',
  /** Deal subtotal API response body */
  DEAL_SUBTOTAL_DTO = 'business/deal-subtotal.dto',
  /** Deal creation and updating requests body */
  DEAL_FORM_DTO = 'business/deal-form.dto',
  /** Deal creation requests body */
  DEAL_CREATE_DTO = 'business/deal-create.dto',
  /** Some activity planned as part of the deal */
  DEAL_EVENT_FIND_DTO = 'business/deal-event-find.dto',
  /** Deal event API query parameters */
  DEAL_EVENT_QUERY_DTO = 'business/deal-event-query.dto',
  /** Deal event creation and updating requests body */
  DEAL_EVENT_FORM_DTO = 'business/deal-event-form.dto',
  /** Deal partial updating requests body */
  DEAL_PARTIAL_UPDATE_FORM_DTO = 'business/deal-partial-update-form.dto',
  /** Deals list request(s) search query */
  DEALS_SEARCH_QUERY_DTO = 'business/deals-search-query.dto',
  /** Deals groups list with pagination query parameters */
  DEALS_GROUPS_PAGE_QUERY_DTO = 'business/deals-groups-page-query.dto',
  /** Deal history find body */
  DEAL_HISTORY_FIND_DTO = 'business/deal-history-find.dto',
  /** Deal history response with pagination API response body */
  DEAL_HISTORY_PAGE_DTO = 'business/deal-history-page.dto',
  /** Deal history list API query parameters */
  /** Deal event type find request body */
  DEAL_EVENT_TYPE_FIND_DTO = 'business/deal-event-type-find.dto',
  /** Deal event type creation and updating requests body */
  DEAL_EVENT_TYPE_FORM_DTO = 'business/deal-event-type-form.dto',
  /** Deal event finish parameters */
  DEAL_EVENT_FINISH_DTO = 'business/deal-event-finish.dto',
  /** Deal event param parameters */
  DEAL_EVENT_PARAM_DTO = 'business/deal-event-param.dto',
  /** Deal event rescheduling parameters */
  DEAL_EVENT_RESCHEDULING_DTO = 'business/deal-event-rescheduling.dto',
  /** Deal helpdesk task form requests body */
  DEAL_HELPDESK_TASK_FORM_DTO = 'business/deal-helpdesk-task-form.dto',
  /** Query parameters (additional options) for search deal API */
  DEAL_HELPDESK_TASK_QUERY_DTO = 'business/deal-helpdesk-task-query.dto',
  /** Projects add and remove APIs requests body */
  DEAL_PROJECT_FORM_DTO = 'business/deal-project-form.dto',
  /** Query parameters (additional options) for search deal API */
  DEAL_PROJECT_QUERY_DTO = 'business/deal-project-query.dto',
  /** Deals tree response body element */
  DEALS_TREE_ITEM_FIND_DTO = 'business/deals-tree-item-find.dto',
  /** Deals tree registry page response body */
  DEALS_TREE_PAGE_DTO = 'business/deals-tree-page.dto',
  /** Deals tree search query parameters */
  DEALS_TREE_QUERY_DTO = 'business/deals-tree-query.dto',
  /** Deals group create or update request body */
  DEALS_GROUP_FORM_DTO = 'business/deals-group-form.dto',
  /** Deal status create or update request body */
  DEAL_STATUS_FORM_DTO = 'business/deal-status-form.dto',
  /** Deal status find many API response body */
  DEAL_STATUS_PAGE_DTO = 'business/deal-status-page.dto',
  /** Deal status partial update request body */
  DEAL_STATUS_PARTIAL_FORM_DTO = 'business/deal-status-partial-form.dto',
  /** Deal status selection settings */
  DEAL_STATUS_SELECT_DTO = 'business/deal-status-select.dto',
  /** Deal status sorting settings */
  DEAL_STATUS_SORT_DTO = 'business/deal-status-sort.dto',
  /** Deals group history response body */
  DEALS_GROUP_HISTORY_FIND_DTO = 'business/deals-group-history-find.dto',
  /** Deals group history response with pagination API response body */
  DEALS_GROUP_HISTORY_PAGE_DTO = 'business/deals-group-history-page.dto',
  /** Deals groups list without pagination query parameters */
  DEALS_GROUP_LIST_QUERY_DTO = 'business/deals-group-list-query.dto',
  /** Deals groups JSON-page response with pagination API response body */
  DEALS_GROUP_PAGE_DTO = 'business/deals-group-page.dto',
  /** Query parameters with filters for JSON "page" with documents from registry related to deal */
  DEAL_REGISTRY_QUERY_DTO = 'business/deal-registry-query.dto',
  /** Deal flat list query parameters */
  DEAL_FLAT_LIST_QUERY_DTO = 'business/deal-flat-list-query.dto',
  /** Deal registry export to file API query parameters */
  DEAL_EXPORT_QUERY_DTO = 'business/deal-export-query.dto',
  /** Deal registry total values response body */
  DEAL_REGISTRY_TOTAL_VALUES_DTO = 'business/deal-registry-total-values.dto',
  /** Deal registry total API response body */
  DEAL_REGISTRY_TOTAL_DTO = 'business/deal-registry-total.dto',
  /** Deal documents widget API response body */
  DEAL_DOCUMENTS_FIND_DTO = 'business/deal-documents-find.dto',
  /** Deal documenst widget API item response body */
  DEAL_DOCUMENTS_ITEM_DTO = 'business/deal-documents-item.dto',
  /** Deal documents widget API query parameters */
  DEAL_DOCUMENTS_QUERY_DTO = 'business/deal-documents-query.dto',
  /** Deal plan fact analytics widget API query parameters */
  DEAL_PLAN_FACT_ANALYTICS_QUERY_DTO = 'business/deal-plan-fact-analytics-query.dto',
  /** Deal plan fact analytics item widget API response body */
  DEAL_PLAN_FACT_ANALYTICS_ITEM_FIND_DTO = 'business/deal-plan-fact-analytics-item-find.dto',
  /** Deal plan fact analytics widget API response body */
  DEAL_PLAN_FACT_ANALYTICS_FIND_DTO = 'business/deal-plan-fact-analytics-find.dto',
  /** Deal type response body */
  DEAL_TYPE_FIND_DTO = 'business/deal-type-find.dto',
  /** Deal type selection settings */
  DEAL_TYPE_SELECT_DTO = 'business/deal-type-select.dto',
  /** Deal type sorting settings */
  DEAL_TYPE_SORT_DTO = 'business/deal-type-sort.dto',
  /** Deal type create or update request body */
  DEAL_TYPE_FORM_DTO = 'business/deal-type-form.dto',
  /** Deal type partial update request body */
  DEAL_TYPE_PARTIAL_FORM_DTO = 'business/deal-type-partial-form.dto',
  /** Deal type list own filters */
  DEAL_TYPE_FILTERS_DTO = 'business/deal-type-filters.dto',
  /** Deal type registry report query parameters */
  DEAL_TYPE_QUERY_DTO = 'business/deal-type-query.dto',
  /** Deal type export to file API query parameters */
  DEAL_TYPE_EXPORT_QUERY_DTO = 'business/deal-type-export-query.dto',
  /** Deal type registry report items page */
  DEAL_TYPE_PAGE_DTO = 'business/deal-type-page.dto',
  /** Rental rate analysis widget API response body item */
  RENTAL_RATE_ANALYSIS_ITEM_DTO = 'business/rental-rate-analysis-item.dto',
  /** Rental rate analysis widget API query parameters */
  RENTAL_RATE_ANALYSIS_QUERY_DTO = 'business/rental-rate-analysis-query.dto',
  /** Rental rate report analytics API query parameters */
  RENTAL_RATE_REPORT_ANALYTICS_QUERY_DTO = 'business/rental-rate-report-analytics.query.dto',
  /** Rental rate report analytics API own settings */
  RENTAL_RATE_REPORT_ANALYTICS_SETTINGS_DTO = 'business/rental-rate-report-analytics-settings.dto',
  /** Rental rate common filters */
  RENTAL_RATE_REPORT_FILTERS_DTO = 'business/rental-rate-report-filters.dto',
  /** Rental rate report registry item response body */
  RENTAL_RATE_REPORT_ITEM_DTO = 'business/rental-rate-report-item.dto',
  /** Rental rate report items API response body */
  RENTAL_RATE_REPORT_ITEMS_PAGE_DTO = 'business/rental-rate-report-items-page.dto',
  /** Rental rate report items API query parameters */
  RENTAL_RATE_REPORT_ITEMS_QUERY_DTO = 'business/rental-rate-report-items-query.dto',
  /** Rental rate report export to file API query parameters */
  RENTAL_RATE_REPORT_EXPORT_QUERY_DTO = 'business/rental-rate-report-export-query.dto',
  /** Rental rate report items selection settings */
  RENTAL_RATE_REPORT_ITEMS_SELECT_DTO = 'business/rental-rate-report-items-select.dto',
  /** Rental rate report items sorting settings */
  RENTAL_RATE_REPORT_ITEMS_SORT_DTO = 'business/rental-rate-report-items-sort.dto',
  /** Rental rate report subtotal item response body */
  RENTAL_RATE_REPORT_SUBTOTAL_ITEM_DTO = 'business/rental-rate-report-subtotal-item.dto',
  /** Rental rate report subtotal API query parameters */
  RENTAL_RATE_REPORT_SUBTOTAL_QUERY_DTO = 'business/rental-rate-report-subtotal-query.dto',
  /** Rental rate report subtotal API own settings */
  RENTAL_RATE_REPORT_SUBTOTAL_SETTINGS_DTO = 'business/rental-rate-report-subtotal-settings.dto',
  /** Rental rate report subtotal API response body */
  RENTAL_RATE_REPORT_SUBTOTAL_DTO = 'business/rental-rate-report-subtotal.dto',
  /** Rental rate report total values response body */
  RENTAL_RATE_REPORT_TOTAL_VALUES_DTO = 'business/rental-rate-report-total-values.dto',
  /** Rental rate report total API response body */
  RENTAL_RATE_REPORT_TOTAL_DTO = 'business/rental-rate-report-total.dto',
  /** Rental rate widget API response body item */
  RENTAL_RATE_WIDGET_ITEM_DTO = 'business/rental-rate-widget-item.dto',
  /** Rental rate widget API query parameters */
  RENTAL_RATE_WIDGET_QUERY_DTO = 'business/rental-rate-widget-query.dto',
}
